import { render, staticRenderFns } from "./EducationalScheduleTimeTable.vue?vue&type=template&id=fd3a1b50&"
import script from "./EducationalScheduleTimeTable.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports